import { render, staticRenderFns } from "./tableDetail.vue?vue&type=template&id=4d29e99d&scoped=true&"
import script from "./tableDetail.vue?vue&type=script&lang=js&"
export * from "./tableDetail.vue?vue&type=script&lang=js&"
import style0 from "./tableDetail.vue?vue&type=style&index=0&id=4d29e99d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d29e99d",
  null
  
)

export default component.exports